exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-text-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  padding-right: 16px;\n}\n\n.search-text-wrapper .clear-quick-filter-icon {\n  cursor: pointer;\n}\n\n.search-text-wrapper .clear-quick-filter-icon.hidden {\n  visibility: hidden;\n}\n\n", ""]);

// exports
